import "./UpcomingMilestones.css";

import { FullRightArrowDark } from "../../../assets";
import { OrganisationTypeConstants } from "../../../constants";
import { UpcomingMilestonePropsWithKey } from "../../../models";
import { useAuth } from "../../../useAuth";
import { Button } from "../../forms";
import { UpcomingMilestone } from "./components";

type UpcomingMilestonesVariant = "default" | "dashboard";

interface UpcomingMilestonesProps {
  variant?: UpcomingMilestonesVariant;
  milestones: UpcomingMilestonePropsWithKey[];
  onViewAll: () => void;
}

export const UpcomingMilestones = ({
  variant = "default",
  milestones,
  onViewAll,
}: UpcomingMilestonesProps): JSX.Element => {
  const { currentUserType } = useAuth();

  return (
    <div
      className={`UpcomingMilestones ${variant} ${currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "Rounded" : ""} ${
        milestones.length > 0 ? "hasData" : ""
      }`}
    >
      <div className="UpcomingMilestonesHeader">
        <p className="body01">Upcoming milestones</p>
        {milestones.length > 0 && (
          <div className="AllUpcomingMilestones">
            <Button
              text="View more"
              onClick={onViewAll}
              variant="secondary"
              icon={<FullRightArrowDark />}
              minWidth={false}
              size="extraSmall"
              hasNoPadding
              fontWeight="light"
            />
          </div>
        )}
      </div>
      {milestones.length > 0 ? (
        <div className="UpcomingMilestonesList">
          {milestones.map((milestone) => (
            <UpcomingMilestone
              key={milestone.key}
              name={milestone.name}
              deadlineDate={milestone.deadlineDate}
              status={milestone.status}
              assigneeName={milestone.assigneeName}
              rounded={currentUserType === OrganisationTypeConstants.ASSET_MANAGER}
              onClick={milestone.onClick}
              project={milestone.project}
              variant={variant}
            />
          ))}
        </div>
      ) : (
        <p className="body2 NoData">No upcoming milestones to display</p>
      )}
    </div>
  );
};
